import { PROVINCE_CODES } from '@repo/constants'
import { z } from 'zod'

/**
 * Province AOV per Carton import. The CSV round-trips the export 1:1, so the header list and its order
 * match the export shape exactly: province code → AOV.
 */
export const importProvinceAovPerCartonHeaders = ['province_code', 'aov'] as const

const provinceCodes: readonly string[] = PROVINCE_CODES

/**
 * Rows whose province code is not recognized by the system fail parsing here and are tracked as
 * invalid (never inserted). `aov` is kept as a string (the column is numeric(12,2)); a blank clears the
 * value (stored as null), a negative or non-numeric value is rejected.
 */
export const importProvinceAovPerCartonSchema = z.object({
  province_code: z
    .string()
    .transform((value) => value.trim().toUpperCase())
    .refine((value) => provinceCodes.includes(value)),
  aov: z
    .string()
    .transform((value) => value.trim())
    .refine((value) => value === '' || (!isNaN(Number(value)) && Number(value) >= 0))
    .transform((value) => (value === '' ? null : value)),
})

export type ImportProvinceAovPerCartonRecord = z.infer<typeof importProvinceAovPerCartonSchema>
